import React, { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import { osName } from 'react-device-detect';
import LoadingOverlay from 'react-loading-overlay';
import _ from 'lodash';
import { createBrowserHistory } from 'history';
import { connect } from 'react-redux';

import { alertActions } from '../../actions';
import { IdField } from '../home/components/index.js';
import StickyBottom from '../../common/stickyButtonFooter/StickyBottom.jsx';
import HomeAlertModal from '../home/homeAlertModal/HomeAlertModal.jsx';
import { commonConstant, CustomCheckbox, Field } from '../../common';
import { Modal, OTPInput } from '../../helpers';
import { customerService, activityService } from '../../services';
import Condition from '../condition/TermsConditions.jsx';
import {
  LABEL_REGISTRATION_ABO_TITLE,
  LABEL_REGISTRATION_ABO_SUBTITLE,
  FIELD_TYPE,
  LABEL_ACCEPT_TNC,
  LABEL_ALERT_NO_PHONE_OK_BTN,
  LABEL_ALERT_NO_PHONE_TITLE,
  LABEL_ALERT_NO_PHONE_DESCRIPTION,
  LABEL_ABO_DATE_OF_BIRTH_PLACEHOLDER,
  LABEL_ALERT_DUPLICATE_DESCRIPTION,
} from '../../common/commonConstant.js';
import './abo.scss';
import { formatWithOptions } from 'date-fns/fp';
import { th } from 'date-fns/locale';

export const history = createBrowserHistory();

class Abo extends Component {
  constructor(props) {
    super(props);

    if (sessionStorage.getItem('customer') === null || sessionStorage.getItem('customer') === 'undefined') {
      window.location.replace(commonConstant.pathHome);
    }

    const customer = JSON.parse(sessionStorage.getItem('customer'));

    if (!customer.type) {
      return window.location.replace(commonConstant.pathHome);
    }

    this.state = {
      customer: customer,
      DistNum: '',
      cid: this.props.location?.state.cid || '',
      loading: false,
      error: false,
      show: false,
      accept: this.props.location?.state.accept || false,
      condition: false,
      isOpenModal: false,
      modalContent: '',
      resMemberNumber: null,
      profile: '',
      isPickerOpen: false,
      selectedDOB: new Date(this.props.location?.state.selectedDOB).getTime() ? this.props.location?.state.selectedDOB : '',
      selectedPartyId: ''
    };
  }

  checkboxRef = createRef();

  componentDidMount() {
    const { location } = this.props;
    if (!location.state || !location.state.myMember || location.state.myMember.accountMst.accountTypeCd !== 'AmwayBusiness')
      return window.location.replace(commonConstant.pathHome);
    this.setState({ profile: location.state.myMember });
    this.checkboxRef.current.checked = this.state.accept;
  }

  onPaste = e => {
    e.preventDefault();
    return false;
  };

  handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === '' || e.target.value.match(regex)) {
      this.setState({ [e.target.name]: e.target.value });
    }
  }
  handleCheckBox = () => {
    this.props.history.replace({
      state: {
        ...this.props.location.state,
        accept: !this.state.accept
      }
    });
    this.setState({ accept: !this.state.accept });
  }
  toggleModal = (content, resMemberNumber = null) => {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
      modalContent: content,
      resMemberNumber,
    });
  }

  handleModalOk = () => {
    const { modalContent, isOpenModal } = this.state;
    this.toggleModal();
    switch (modalContent) {
      case 'duplicate':
        this.setState({ isOpenModal: !isOpenModal });
        return this.props.history.push('/changeMID', { myMember: this.props.location.state.myMember, oldLineId: this.state.oldLineId, oldMember: this.state.oldMember, partyId: this.state.selectedPartyId });
      case 'wrongCid':
        this.props.history.replace({
          state: {
            ...this.props.location.state,
            accept: !this.state.accept
          }
        });
        this.setState({ isOpenModal: !isOpenModal, accept: false, selectedDOB: '' });
        this.checkboxRef.current.checked = false;
        return;
      case 'phoneNotFound':
        this.setState({ isOpenModal: !isOpenModal });
        return window.location = 'tel:027258000';
      default:
        break;
    }
  }

  handleModalContent = () => {
    const { modalContent, profile } = this.state;
    switch (modalContent) {
      case 'duplicate':
        return { title: `หมายเลขนี้มีการผูกกับ LINE`, detail: LABEL_ALERT_DUPLICATE_DESCRIPTION(this.state?.oldMember?.displayName), btnText: 'เปลี่ยนบัญชี', cancelBtnText: 'ยกเลิก' };
      case 'card':
        return { title: null, detail: '<img src="/images/id-card-hint.png" alt="" />' };
      case 'invalidbd':
      case 'wrongBirthDay':
      case 'wrongCid':
        return { title: 'ข้อมูลส่วนตัวไม่ถูกต้อง', detail: 'กรุณาระบุข้อมูลส่วนตัวของคุณใหม่อีกครั้ง', btnText: 'ระบุข้อมูลใหม่' }
      case 'phoneNotFound':
        return {
          title: LABEL_ALERT_NO_PHONE_TITLE, detail: LABEL_ALERT_NO_PHONE_DESCRIPTION,
          btnText: LABEL_ALERT_NO_PHONE_OK_BTN, btnCss: 'p-lr-40'
        }
      default:
        break;
    }
  }


  getNameFromPartyId = (profile, partyId) => {
    if (!profile || !Array.isArray(profile.partyList)) {
      return '';
    }
  
    const party = profile.partyList.find(
      (p) => String(p?.partyMst?.partyId) === String(partyId)
    );
  

    if (!party) return '';
  

    if (party.partyMst?.partyTypeCd !== 'Person') {
      return '';
    }
  
  
    if (Array.isArray(party.nameList) && party.nameList[0]?.localeName) {
      const { title, givenName, familyName } = party.nameList[0].localeName;
      const fullName = [title, givenName, familyName]
        .filter(Boolean)
        .join(' ')
        .trim();
  
      if (fullName) return fullName;
    }
  
  
    if (Array.isArray(party.nameList) && party.nameList[0]?.latinName) {
      const { title, givenName, familyName } = party.nameList[0].latinName;
      const fullName = [title, givenName, familyName]
        .filter(Boolean)
        .join(' ')
        .trim();
  
      if (fullName) return fullName;
    }
  

    return '';
  };
  


  handleSubmit = async (e) => {
    window.scrollTo(0, 1);
    const { cid, selectedDOB, profile } = this.state;
    const amwayNumber = profile.accountMst.aboNum;
    let findIndex = -1;
    let citizenId = '';
    let customer = {};
    let userGender = '';
    let phoneList;
    e.preventDefault();
    this.setState({ loading: true });

    // const searchKey = amwayNumber + cid;

    if (cid) {
      const cleanData = _.filter(profile.partyList, function (o) {
        return o.taxList[0] && o.taxList[0].taxTypeCd === 'CID' && o.partyMst && o.partyMst.roleCd && o.partyMst.roleCd === 'BusinessOwner';
      });
      const last4Digit = cleanData.map(function (raw) {
        return raw.taxList[0].taxId;
      });

      const accountProfile = _.filter(profile.partyList, function (o) { return o.taxList[0] && o.taxList[0].taxId.substr(-4) === cid; });
      const profileSchema = {
        familyName: '',
        givenName: '',
        middleName: '',
        suffix: '',
        title: '',
      };

      if (accountProfile.length > 0) {
        const localNameObj = accountProfile[0].nameList[0].localeName;
        profileSchema.familyName = (localNameObj.familyName !== null) ? localNameObj.familyName : '';
        profileSchema.givenName = (localNameObj.givenName !== null) ? localNameObj.givenName : '';
        profileSchema.middleName = (localNameObj.middleName !== null) ? localNameObj.middleName : '';
        profileSchema.suffix = (localNameObj.suffix !== null) ? localNameObj.suffix : '';
        profileSchema.title = (localNameObj.title !== null) ? localNameObj.title : '';
      }

      const AboName = `${profileSchema.givenName} ${profileSchema.familyName}`;

      let found = false;
      for (let i in last4Digit) {
        if (last4Digit[i].substr(-4) === cid) {
          found = true;
          citizenId = last4Digit[i];
          break;
        }
      }

      findIndex = profile.partyList.findIndex(party => {
        return party.taxList[0]?.taxId.substr(-4) === cid;
      });

      if (found && findIndex !== -1) {
        userGender = profile.partyList[findIndex].partyMst.genderCd || '';
      }

      if (!found) {
        this.setState({ isOpenModal: false, loading: false });
        this.toggleModal('wrongCid');
        return;
      }

      let partyId = null;
      let selectedParty = null;
      profile.partyList.map(party => {
        const tax = party.taxList[0]
        if (tax?.taxTypeCd === 'CID' && citizenId === tax?.taxId) {
          partyId = tax.partyId;
          selectedParty = party;
        }
      })

      this.setState({ selectedPartyId: partyId });

      const { location } = this.props;

      if (location?.state?.myMember && findIndex !== -1) {
        phoneList = location?.state?.myMember?.partyList?.length && location?.state?.myMember?.partyList[findIndex].phoneList?.length
          && location?.state?.myMember?.partyList[findIndex].phoneList.find((list) => list?.phoneLocalNum?.trim() !== '' && list?.contactPointTypeCd === 'Mobile' && Array.isArray(list?.usageList) && list?.usageList.find((usage) => usage?.primaryFlag));
      }

      const resMemberNumber = await customerService.findMemberByPartyId(amwayNumber, partyId);
      if (resMemberNumber && (resMemberNumber.uid !== this.state.customer.uid) && (cid === resMemberNumber.cid)) {
        if (!phoneList) {
          this.setState({ isOpenModal: false, loading: false });
          this.toggleModal('phoneNotFound');
          return;
        }
        this.setState({ isOpenModal: false, loading: false, oldLineId: resMemberNumber.uid, oldMember: resMemberNumber });
        this.toggleModal('duplicate', resMemberNumber);
        return;
      }

      if (selectedParty && selectedParty?.partyMst?.czshpCntryCd !== 'TH') {
        this.setState({ isOpenModal: false, loading: false });
        this.toggleModal('invalidbd');
        return
      }


      const ABOname =
      this.getNameFromPartyId(profile, partyId) ||
      profile.accountMst.accountLocalName ||
      profile.accountMst.accountName ||
      '';

      customer = {
        ...this.state.customer,
        name: ABOname,
        _id: this.state.customer._id,
        cid: citizenId.substr(-4),
        info: osName === 'IOS' ? 'iPhone' : osName,
        amwayNumber: parseInt(amwayNumber),
        gender: userGender.toLowerCase(),
        // partyId: profile.accountMst.primaryPersonPartyId,
        partyId: partyId,
        socialType: 'LINE',
        ...(phoneList ? { phone: phoneList.phoneLocalNum } : null)
      };

      // customer.name = AboName;
      sessionStorage.setItem('customer', JSON.stringify(customer));
    } else if (selectedDOB) {

      if (!this.handleCheckValidDate()) {
        this.toggleModal('invalidbd');
        this.setState({ loading: false });
        return false;
      }

      const date = this.state.selectedDOB;
      const dateString = `${date.getFullYear()}-${(date.getMonth() + 1 + '').padStart(2, '0')}-${(date.getDate() + '').padStart(2, '0')}`;
      const searchKey = amwayNumber + dateString;
      let userBirthDate = null;
      let inputBirthDate = '';

      findIndex = profile.partyList.findIndex(party => {
        return party.partyMst.birthdate.substr(0, 10) === dateString;
      });

      if (findIndex !== -1) {
        if (profile.partyList[findIndex].partyMst.czshpCntryCd === 'TH') {
          this.setState({ isOpenModal: false, loading: false });
          this.toggleModal('invalidbd');
          return;
        }
        inputBirthDate = dateString;
        userBirthDate = profile.partyList[findIndex].partyMst.birthdate.substr(0, 10);
        userGender = profile.partyList[findIndex].partyMst.genderCd || '';
      } else {
        this.setState({ isOpenModal: false, loading: false });
        this.toggleModal('wrongBirthDay');
        return
      }

      let partyId2 = profile.partyList[findIndex].partyMst.partyId;
      this.setState({ selectedPartyId: partyId2 });

      citizenId = searchKey;
      if (profile && findIndex !== -1) {
        citizenId = profile.partyList[findIndex].taxList.length ? profile.partyList[findIndex].taxList[0].taxId : citizenId;
      }

      const { location } = this.props;

      if (location?.state?.myMember && findIndex !== -1) {
        phoneList = location?.state?.myMember?.partyList?.length && location?.state?.myMember?.partyList[findIndex].phoneList?.length
          && location?.state?.myMember?.partyList[findIndex].phoneList.find((list) => list?.phoneLocalNum?.trim() !== '' && list?.contactPointTypeCd === 'Mobile' && Array.isArray(list?.usageList) && list?.usageList.find((usage) => usage?.primaryFlag));
      }

      const myMember = await customerService.findMemberByPartyId(amwayNumber, partyId2);

      if (myMember && (myMember.uid !== this.state.customer.uid) && myMember.partyId == partyId2) {
        if (!phoneList) {
          this.setState({ isOpenModal: false, loading: false });
          this.toggleModal('phoneNotFound');
          return;
        }
        this.setState({ isOpenModal: false, loading: false, oldLineId: myMember.uid, oldMember: myMember });
        this.toggleModal('duplicate');
        return false;
      }

      const ABOname =
      this.getNameFromPartyId(profile, partyId2) ||
      profile.accountMst.accountLocalName ||
      profile.accountMst.accountName ||
      '';

      customer = {
        ...this.state.customer,
        name: ABOname,
        _id: this.state.customer._id,
        amwayNumber: parseInt(amwayNumber),
        birthday: dateString,
        gender: userGender.toLowerCase(),
        partyId: partyId2,
        socialType: 'LINE',
        ...(phoneList ? { phone: phoneList.phoneLocalNum } : null)
      };
      sessionStorage.setItem('customer', JSON.stringify(customer));
    }

    if (!phoneList) {
      this.setState({ isOpenModal: false, loading: false });
      this.toggleModal('phoneNotFound');
      return;
    }

    // TODO Delete after testing
    // activityService.create({
    //   uid: this.state.customer.uid,
    //   userId: this.state.customer._id,
    //   status: 'incomplete',
    //   action: 'VERIFY_ABO',
    // });
    // ------- End ABO Verify --------------------------------------------------------------
    console.log("End ABO Verify");
    return this.props.history.push(commonConstant.pathVerifyOtp, {
      myMember: this.props.location.state.myMember,
      user: customer,
      phoneList,
      detailType: 'abo'
    });
  };

  handlePickerSubmit = (pickerValue) => {
    this.setState({
      selectedDOB: pickerValue,
      isPickerOpen: false,
    });
  };

  handlePickerDelete = () => {
    this.setState({
      selectedDOB: '',
      isPickerOpen: false,
    });
  };

  handleCheckValidDate = () => this.state?.selectedDOB?.getTime();

  render() {
    const { cid, isOpenModal, accept, profile, selectedDOB } = this.state;
    const { location } = this.props;

    const isTrue = (cid.length === 4 || selectedDOB) && accept;
    const content = this.handleModalContent();
    return (
      <div className="abo">
        <LoadingOverlay active={this.state.loading} spinner text="Loading" styles={{ wrapper: { width: '100%', minHeight: '100%' } }} />
        {isOpenModal &&
          <HomeAlertModal
            title={content.title}
            description={content.detail}
            btnFn={this.handleModalOk}
            cancelBtnFn={this.toggleModal}
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            cancelBtnText={content.cancelBtnText}
            btnText={content.btnText}
            btnCss={content?.btnCss} />
        }
        <form className="registration-form" onSubmit={this.handleSubmit}>
          <div className="logoAmway">
            <img src="/images/registration/AmwayLineBusinessConnectLogo.png" alt="" />
          </div>
          <div className="title">{LABEL_REGISTRATION_ABO_TITLE}</div>
          <div className="subtitle">{LABEL_REGISTRATION_ABO_SUBTITLE}</div>
          <div className="amwayNumber">{profile && profile.accountMst.aboNum}</div>
          <div className="cid-form">
            <div className="cid-form-label">หมายเลขบัตรประชาชน 4 หลักสุดท้าย</div>
            <OTPInput inputArray={cid ? cid.split('') : null} id="cid" disable={this.state.selectedDOB} count={4} onChange={(value, obj) => this.handleChange({ target: { name: obj.id, value: obj.value } })} />
            <div className="cid-form-label">หรือ</div>
            <IdField
              heading="วันเกิด"
              placeholder={LABEL_ABO_DATE_OF_BIRTH_PLACEHOLDER}
              disabled={this.state.cid}
              type={FIELD_TYPE.Date}
              value={this.state.selectedDOB && formatWithOptions({ locale: th }, 'd MMMM yyyy')(this.state.selectedDOB)}
              onDateSubmit={this.handlePickerSubmit}
              onDateDelete={this.handlePickerDelete}
              isPickerOpen={this.state.isPickerOpen}
              preIconPath='/images/common/CalendarIcon.png'
              preIconDisabledPath='/images/common/CalendarIconDisabled.png' />
            <div className="business-owners-label">*สำหรับนักธุรกิจแอมเวย์ชาวต่างชาติ (For foreign ABO)</div>
          </div>
          <div className="abo-text-notice">ข้อมูลส่วนตัวของท่านจะได้รับการปกป้องอย่างปลอดภัย</div>

          <StickyBottom buttonProps={{ type: 'submit' }} buttonText="ถัดไป" isActive={isTrue}>
            <div className="home-registration-tnc-wrapper">
              <CustomCheckbox onChange={this.handleCheckBox} accept={accept} ref={this.checkboxRef} />
              <div className="home-registration-tnc-link">
                <Link className="" to={{
                  pathname: '/condition',
                  state: { from: location, cid, accept, selectedDOB },
                }}>{LABEL_ACCEPT_TNC}</Link>
              </div>
            </div>
          </StickyBottom>
        </form>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showError: (message) => dispatch(alertActions.showError(message)),
  };
}

export default connect(null, mapDispatchToProps)(Abo);
